var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"preload-video"}},[_c('video',{attrs:{"playsinline":"","preload":"auto","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"type":"video/webm"}}),_c('source',{attrs:{"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }